exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-0d5141c8] .v-select .v-field .v-field__input > input {\n  opacity: 0 !important;\n  overflow-y: hidden !important;\n  height: 50px !important;\n}\n", ""]);

// exports
